<template>
    <div class='main'>
        <div class='content'>
            <div class='content-header'>
                <h5>注文一覧</h5>
            </div>
            <p v-if='loading' class='message'>読み込み中...</p>
            <p v-else-if='!displayOrders.length' class='message'>注文履歴はありません。</p>
            <div v-else class='order-list'>
                <div v-for='order in displayOrders' :key='order.id' class='order-card'>
                    <div class='order-card-header'>
                        <div>
                            <p class='order-number-text'>{{ order.orderNumberText }}</p>
                            <p class='order-date'>{{ order.createdAtText }}</p>
                        </div>
                    </div>
                    <div class='order-summary'>
                        <div>
                            <span class='summary-label'>合計</span>
                            <strong>{{ order.amountText }}</strong>
                        </div>
                        <div>
                            <span class='summary-label'>数量</span>
                            <strong>{{ order.quantity }}</strong>
                        </div>
                    </div>
                    <p v-if='order.photos[0] && order.photos[0].child'>お子さま：{{ order.photos[0].child.name }}</p>
                    <section class='ordered-photos'>
                        <h6>注文画像</h6>
                        <div v-if='order.photos.length' class='ordered-photo-grid'>
                            <button
                                v-for='photo in order.photos'
                                :key='`${order.id}-${photo.id}-${photo.size}`'
                                class='ordered-photo'
                                type='button'
                                :disabled='!photo.available'
                                @click='openPhoto(photo)'
                            >
                                <img
                                    v-if='photo.available'
                                    :src='photoUrl(photo)'
                                    :alt='photo.name'
                                    loading='lazy'
                                    decoding='async'
                                >
                                <span v-else class='photo-unavailable'>画像の保存期間が終了しています</span>
                                <span class='ordered-photo-name'>{{ photo.name }}</span>
                                <span class='ordered-photo-meta'>{{ photo.size }} / {{ photo.length }}枚</span>
                            </button>
                        </div>
                        <p v-else class='photo-unavailable-message'>注文画像の情報がありません。</p>
                    </section>
                    <dl class='order-details'>
                        <div>
                            <dt>サイズ</dt>
                            <dd>{{ order.sizeSummary }}</dd>
                        </div>
                        <div>
                            <dt>配送</dt>
                            <dd>{{ order.delivery }}</dd>
                        </div>
                        <div>
                            <dt>決済方法</dt>
                            <dd>{{ order.payment }}</dd>
                        </div>
                        <div>
                            <dt>お名前</dt>
                            <dd>{{ order.name }}</dd>
                        </div>
                        <div>
                            <dt>住所</dt>
                            <dd>{{ order.address }}</dd>
                        </div>
                        <div>
                            <dt>連絡先</dt>
                            <dd>{{ order.phone }}</dd>
                        </div>
                        <div>
                            <dt>メール</dt>
                            <dd>{{ order.email }}</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
        <div class='modal photo-modal' :class='{ "is-active": detailPhoto }'>
            <div class='modal-background' @click='closePhoto'></div>
            <div v-if='detailPhoto' class='modal-card'>
                <div class='modal-image-wrapper'>
                    <img :src='photoUrl(detailPhoto)' :alt='detailPhoto.name'>
                </div>
                <footer class='modal-card-foot'>
                    <div>
                        <p class='modal-photo-name'>{{ detailPhoto.name }}</p>
                        <p class='modal-photo-meta'>{{ detailPhoto.size }} / {{ detailPhoto.length }}枚</p>
                    </div>
                    <button class='button' type='button' @click='closePhoto'>閉じる</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Order',
    components: {
    },
    data () {
        return {
            orders: [],
            loading: true,
            photoBaseUrl: process.env.PHOTO_BASE_URL,
            detailPhoto: null
        }
    },
    computed: {
        displayOrders () {
            return this.orders.map((order) => {
                const photos = Array.isArray(order.photos) ? order.photos : []
                const sizes = []
                photos.forEach((photo) => {
                    if (photo.size && sizes.indexOf(photo.size) === -1) sizes.push(photo.size)
                })

                return {
                    ...order,
                    photos,
                    orderNumberText: order.display_order_number || order.order_number || `#${order.id}`,
                    createdAtText: this.getDate(order.created_at),
                    amountText: `${this.formatAmount(order.amount)}円`,
                    sizeSummary: sizes.length ? sizes.join('、') : '-'
                }
            })
        }
    },
    mounted () {
        const self = this

        self.axios.get(`${process.env.API_URL}/photobuy/order`).then((res) => {
            self.orders = res.data.orders || []
        }).catch((e) => {
            self.$root.$emit('notification', 'is-danger', 'サーバーエラーが発生しました')
        }).finally(() => {
            self.loading = false
        })
    },
    methods: {
        photoUrl (photo) {
            const key = photo.reductionS3Key || photo.s3Key
            return key ? `${this.photoBaseUrl}/${key}` : ''
        },
        openPhoto (photo) {
            if (!photo.available) return
            this.detailPhoto = photo
        },
        closePhoto () {
            this.detailPhoto = null
        },
        formatAmount (amount) {
            const number = Number(amount)
            if (isNaN(number)) return amount
            return number.toLocaleString('ja-JP')
        },
        getDate (x) {
            if (!x) return ''
            const date = new Date(x)

            const y = date.getFullYear()
            const m = ('0' + (date.getMonth() + 1)).slice(-2)
            const d = ('0' + date.getDate()).slice(-2)
            const h = ('0' + date.getHours()).slice(-2)
            const mn = ('0' + date.getMinutes()).slice(-2)
            const s = ('0' + date.getSeconds()).slice(-2)

            return `${y}-${m}-${d} ${h}:${mn}:${s}`
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}

.content {
    padding: 25px;
    margin: auto;
    min-width: 0;
}

.content-header {
    margin-bottom: 16px;
}

.content-header h5 {
    font-weight: bold;
}

.message {
    margin-top: 24px;
    color: #555;
}

.order-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.order-card {
    border: 1px solid #e2e5ea;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
}

.order-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    padding: 12px;
    background: #f8f9fb;
    border-bottom: 1px solid #e2e5ea;
}

.order-number-text {
    margin: 0;
    font-size: 13px;
    font-weight: bold;
    color: #222;
    word-break: break-all;
}

.order-date {
    margin-top: 4px;
    font-size: 12px;
    color: #666;
}

.order-summary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1px;
    background: #e8ebf0;
}

.order-summary > div {
    background: #fff;
    padding: 10px 12px;
}

.summary-label {
    display: block;
    margin-bottom: 2px;
    color: #777;
    font-size: 11px;
}

.order-summary strong {
    color: #222;
    font-size: 18px;
    line-height: 1.2;
}

.order-details {
    padding: 4px 12px 12px;
}

.ordered-photos {
    padding: 12px;
    border-top: 1px solid #eef0f3;
}

.ordered-photos h6 {
    margin: 0 0 10px;
    color: #333;
    font-size: 13px;
    font-weight: bold;
}

.ordered-photo-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
}

.ordered-photo {
    display: flex;
    min-width: 0;
    padding: 0;
    overflow: hidden;
    flex-direction: column;
    border: 1px solid #dfe3e8;
    border-radius: 6px;
    background: #fff;
    color: inherit;
    text-align: left;
    cursor: pointer;
}

.ordered-photo:disabled {
    cursor: default;
    opacity: 0.8;
}

.ordered-photo img {
    width: 100%;
    height: 130px;
    object-fit: contain;
    background: #f4f5f7;
    image-orientation: from-image;
}

.ordered-photo-name,
.ordered-photo-meta {
    width: 100%;
    padding: 0 7px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ordered-photo-name {
    margin-top: 7px;
    font-size: 12px;
    font-weight: 600;
}

.ordered-photo-meta {
    padding-top: 2px;
    padding-bottom: 7px;
    color: #666;
    font-size: 11px;
}

.photo-unavailable {
    display: flex;
    width: 100%;
    height: 130px;
    padding: 12px;
    align-items: center;
    justify-content: center;
    background: #f4f5f7;
    color: #777;
    font-size: 11px;
    text-align: center;
}

.photo-unavailable-message {
    color: #777;
    font-size: 12px;
}

.photo-modal {
    z-index: 300;
}

.modal-card {
    max-width: min(900px, 95vw);
    max-height: 95vh;
}

.modal-image-wrapper {
    display: flex;
    min-height: 200px;
    align-items: center;
    justify-content: center;
    overflow: auto;
    background: #111;
}

.modal-image-wrapper img {
    max-width: 100%;
    max-height: calc(95vh - 80px);
    object-fit: contain;
    image-orientation: from-image;
}

.modal-card-foot {
    display: flex;
    justify-content: space-between;
    gap: 12px;
}

.modal-photo-name,
.modal-photo-meta {
    margin: 0;
    overflow-wrap: anywhere;
}

.modal-photo-name {
    font-weight: bold;
}

.modal-photo-meta {
    margin-top: 3px;
    color: #666;
    font-size: 12px;
}

.order-details > div {
    display: grid;
    grid-template-columns: 68px minmax(0, 1fr);
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px solid #f0f1f3;
}

.order-details > div:last-child {
    border-bottom: none;
}

.order-details dt {
    color: #777;
    font-size: 12px;
    font-weight: normal;
}

.order-details dd {
    color: #222;
    font-size: 13px;
    line-height: 1.45;
    min-width: 0;
    overflow-wrap: break-word;
}

@media (max-width: 900px) {
    .content {
        padding: 12px 10px 24px;
    }

    .content-header {
        margin-bottom: 12px;
    }

    .ordered-photo-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 600px) {
    .ordered-photo-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 5px;
    }

    .ordered-photo img,
    .photo-unavailable {
        height: 110px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/OrderHistory.vue